<template>
  <div class="verval">
    <!--daftar-->
    <v-card tile flat class="bg-card">
      <v-card-text class="pa-0">
        <v-row no-gutters>
          <v-col cols="12" class="pa-5">
            <h1 class="headline black--text--text">
              Verval Kelas Diklat {{ $titleCase(akses === 'refreshment' ? 'PPM & PPTM' : akses) }}
            </h1>
            <div> </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <div
      v-if="jenis === 'kelas-luring'"
      :style="{
        display: 'flex',
        flexDirection: this.$vuetify.breakpoint.mobile ? 'column' : 'row',
        gap: '10px',
        width: '100%',
        margin: '0 auto',
      }"
      class="mb-6"
    >
      <!-- Item -->
      <div
        v-for="(box, id) in boxes"
        :key="id"
        style="flex: 1; text-align: center; padding: 1px; border-radius: 5px"
        :class="[box.color]"
      >
        <v-list :class="[box.color, 'lighten-5 pa-0']" style="border-radius: 5px">
          <v-list-item>
            <v-list-item-icon class="mr-0">
              <v-icon size="60" :color="box.color">
                {{ box.icon }}
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content class="ml-n7">
              <div :class="`font-weight-bold ${box.color}--text`">
                {{ box.label }}
              </div>
              <h2 :class="`${box.color}--text`">
                {{ box.value }}
              </h2>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </div>
    </div>
    <v-card flat>
      <v-card-text class="pa-0">
        <base-table-header
          btn-filter
          :btnDownload="$allow(`${this.jenis}-verval.download`) || $allow(`${this.jenis}-kelas-luring`)"
          @download="onDownload"
          @filter="onFilter"
          @search="onSearch"
          @reload="onReload"
        >
          <template v-slot:subtitle>
            <div class="body-1 black--text">
              <b>{{ total }}</b> Ajuan Verval
            </div>
          </template>
          <template v-slot:toolbar>
            <div v-if="jenis === 'kelas-luring'" style="width: 180px">
              <v-select
                v-model="tahun"
                class="mt-7 mr-1"
                light
                flat
                dense
                outlined
                :items="mTahun"
                @change="fetchData"
              ></v-select>
            </div>
          </template>
        </base-table-header>
        <v-divider />
        <base-list-filter
          ref="filter"
          title="Pilih Filter Status"
          :filtered="filtered"
          :filters="formFilter"
          :paramsFilter="filters"
          @save="filterSave"
        />
        <base-list-table
          :hideHeader="true"
          :loading="loading"
          :item="data"
          :total="total"
          :usePaging="false"
          @fetch="initFetch"
        >
          <template slot-scope="{ item }">
            <td>
              <v-list three-line class="py-0">
                <v-list-item class="pa-0">
                  <v-list-item-icon class="mr-5">
                    <v-icon color="primary" size="50">mdi-google-classroom</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-row>
                      <v-col cols="12" md="4" @click="onVerval(item)">
                        <div class="caption"> Nama Kelas </div>
                        <span class="body-1 black--text">
                          {{ item.nama || '-' }}
                        </span>
                        <div class="font-italic grey--text text--darken-1">
                          {{ $getDeepObj(item, `paud_diklat${label}.instansi.nama`) || '-' }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="2">
                        <div class="caption">Tanggal Pelaksanaan</div>
                        <div v-if="akses === 'daring'">
                          {{
                            $durasi(
                              $getDeepObj(item, 'paud_diklat.paud_periode.tgl_diklat_mulai'),
                              $getDeepObj(item, 'paud_diklat.paud_periode.tgl_diklat_selesai'),
                              { shortDate: true }
                            )
                          }}
                        </div>
                        <div v-else>
                          {{
                            $durasi(
                              $getDeepObj(item, `paud_diklat${label}.tgl_mulai`),
                              $getDeepObj(item, `paud_diklat${label}.tgl_selesai`),
                              { shortDate: true }
                            )
                          }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="2">
                        <div class="caption">Jenis Diklat</div>
                        <div class="link black--text body-2">
                          <template v-if="['refreshment'].includes(akses)">
                            {{ $getDeepObj(item, `paud_diklat${label}.m_diklat${label}_paud.keterangan`) }}
                          </template>
                          <template v-else>
                            {{ $getDeepObj(item, `paud_diklat${label}.m_diklat_paud.keterangan`) }}
                          </template>
                        </div>
                        <div class="caption mt-2">Jenjang Diklat</div>
                        <div>
                          {{ $getDeepObj(item, `paud_diklat${label}.m_jenjang_diklat_paud.keterangan`) }}
                        </div>
                      </v-col>
                      <v-col cols="12" md="2">
                        <div class="caption">Status</div>
                        <div>
                          <v-chip :color="getColor(item.k_verval_paud)" dark small>
                            {{ $getDeepObj(item, `m_verval_paud.keterangan`) }}
                          </v-chip>
                          <div v-if="[4, 5].includes(Number(item.k_verval_paud))" class="mt-2">
                            <v-btn text x-small color="orange darken-1" @click="onCatatan(item)">
                              Catatan <v-icon small>mdi-file-edit</v-icon>
                            </v-btn>
                          </div>
                          <div
                            v-if="[6].includes(Number(item.k_verval_paud)) && akses === 'daring'"
                            class="link black--text body-2 mt-1"
                          >
                            <span :class="item.wkt_sync ? 'success--text caption' : 'red--text caption'">
                              {{ item.wkt_sync ? 'Sudah Sinkronisasi' : 'Belum Sinkronisasi' }}
                              <v-tooltip v-if="!item.wkt_sync" bottom>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon small color="warning" v-bind="attrs" v-on="on">mdi-help-circle</v-icon>
                                </template>
                                <span>Silakan melakukan aksi sinkronisasi</span>
                              </v-tooltip>
                            </span>
                          </div>
                        </div>
                      </v-col>
                      <v-col cols="12" md="2">
                        <div
                          v-if="isAksi.includes(Number(item.k_verval_paud)) && $allow('kelas-verval.update-verval')"
                          class="caption"
                        >
                          Aksi Selanjutnya
                        </div>
                        <div v-else-if="item.k_verval_paud > 2 && akses === 'luring'" class="caption">
                          Waktu Verval
                        </div>
                        <div>
                          <v-btn
                            v-if="[2].includes(Number(item.k_verval_paud)) && $allow('kelas-verval.update-verval')"
                            color="primary"
                            small
                            @click="onVerval(item)"
                          >
                            Verval Ajuan
                          </v-btn>
                          <v-btn
                            v-else-if="
                              [6].includes(Number(item.k_verval_paud)) &&
                              akses === 'daring' &&
                              $allow('kelas-verval.sync-kelas')
                            "
                            color="success"
                            small
                            @click="onSync(item)"
                            :disabled="!!isEndDiklat(item)"
                          >
                            Sinkronisasi
                          </v-btn>
                          <div v-else-if="item.k_verval_paud > 2 && akses === 'luring'">
                            {{ $localDate(item.wkt_verval, true, true, false, false, true) }}
                          </div>
                        </div>
                      </v-col>
                      <v-col v-if="catatans[getId(item)]" cols="12" sm="12" md="12" class="px-0 pb-0">
                        <v-alert text color="orange" class="ml-3">
                          <div class="black--text body-2">
                            <b>Catatan:</b> <br />
                            {{ item.alasan }}
                          </div>
                        </v-alert>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                  <v-list-item-action-text>
                    <base-list-action :data="item" :actions="actions" :allow="allow" @action="onAction" />
                  </v-list-item-action-text>
                </v-list-item>
              </v-list>
            </td>
          </template>
        </base-list-table>
      </v-card-text>
      <v-card-actions>
        <base-table-footer :pageTotal="pageTotal" :allow="!allow" @changePage="onChangePage"></base-table-footer>
      </v-card-actions>
    </v-card>
    <base-modal-full
      ref="modal"
      colorBtn="primary"
      :title="formulir['title']"
      :autoClose="formulir['autoClose']"
      :useSave="formulir['is_edit']"
      fluid
      @close="onClose"
      @save="onSave"
    >
      <form-verval
        ref="formulir"
        :masters="Object.assign({}, masters)"
        :id="formulir['id']"
        :detail="formulir['detail']"
        :berkas="formulir['berkas']"
        :fungsi="formulir['fungsi']"
        :isEdit="formulir['is_edit']"
        :isDisable="formulir['is_disable']"
        :initValue="formulir['init']"
        :jenis="jenis"
        :obj="obj"
        :akses="akses"
      ></form-verval>
    </base-modal-full>
  </div>
</template>

<script>
import actions from './actions';
import { mapActions, mapState } from 'vuex';
import list from '@mixins/list';
import FormVerval from '../../formulir/Verval';
export default {
  name: 'Index',
  mixins: [list],
  data() {
    return {
      formulir: {},
      listTimVerval: [],
      listLaporan: [],
      included: [],
      actions: actions,
      tahun: '',
      mPeriode: {},
      M_DIKLAT_PAUD: {
        1: 'Diklat Berjenjang',
        2: 'Diklat BCP',
        3: 'Diklat MOT',
        4: 'Diklat Lainnya',
      },
      M_DIKLAT_REFRESHMENT: {
        1: 'BIMTEK_PPM	Bimtek Penyegaran Pengajar Pendalaman Materi',
        2: 'BIMTEK_PPTM	Bimtek Pembekalan Pembimbing Praktik Tugas Mandiri',
      },
      M_JENJANG_DIKLAT_PAUD: {
        1: 'Dasar',
        2: 'Lanjut',
        3: 'Mahir',
      },
      M_LABEL: {
        daring: '',
        luring: '_luring',
        refreshment: '_bimtek',
      },
      catatans: {},
      boxes: [
        {
          key: 'total',
          icon: 'mdi-file-move',
          color: 'indigo',
          label: 'Total Ajuan',
          value: 0,
        },
        {
          key: 'diajukan',
          icon: 'mdi-file-edit',
          color: 'purple',
          label: 'Diajukan',
          value: 0,
        },
        {
          key: 'disetujui',
          icon: 'mdi-file-check',
          color: 'success',
          label: 'Disetujui',
          value: 0,
        },
        {
          key: 'revisi',
          icon: 'mdi-file-alert',
          color: 'warning',
          label: 'Revisi',
          value: 0,
        },
        {
          key: 'ditolak',
          icon: 'mdi-file-excel',
          color: 'red',
          label: 'Ditolak',
          value: 0,
        },
      ],
    };
  },
  components: { FormVerval },
  computed: {
    ...mapState('master', {
      masters: (state) => Object.assign({}, state.masters),
    }),

    ...mapState('preferensi', {
      akun: (state) => (state.data && state.data.akun) || {},
    }),

    isAksi() {
      if (this.akses === 'daring') {
        return this.$allow('kelas-verval.sync-kelas') ? [2, 6] : [6];
      } else {
        return [2];
      }
    },

    configs() {
      const M_PROPINSI = (this.masters && this.masters['propinsi']) || {};
      const M_KOTA = (this.masters && this.masters['kota']) || {};
      return {
        selector: ['k_propinsi', 'k_kota'],
        required: [false, false],
        label: ['Provinsi', 'Kota/Kabupaten'],
        options: [M_PROPINSI, M_KOTA],
        grid: [{ cols: 12 }, { cols: 12 }],
        disabled: [],
      };
    },

    mTahun() {
      let result = [{ text: 'Semua Tahun', value: '' }];

      for (let year = new Date().getFullYear(); year >= 2021; year--) {
        result.push({ text: `${year.toString()}`, value: year.toString() });
      }

      return result;
    },

    mapStatusVerval() {
      const masters = (this.masters && this.masters.m_verval_paud) || {};
      let temp = {};

      Object.keys(masters).forEach((item) => {
        if (![1, 3].includes(Number(item))) {
          this.$set(temp, item, masters[item]);
        }
      });

      return temp;
    },

    formFilter() {
      let temp = [
        {
          label: 'Pilih Status Verval',
          default: true,
          type: 'select',
          multiple: true,
          model: 'k_verval_paud',
          master: this.$mapForMaster(this.mapStatusVerval),
          props: ['attach', 'chips', 'deletable-chips', 'multiple', 'small-chips'],
          grid: { cols: 12, md: this.akses === 'daring' ? 6 : 12 },
          hideDetails: true,
        },
      ];

      if (this.akses === 'daring') {
        temp.push({
          label: 'Periode Diklat',
          type: 'select',
          model: 'paud_periode_id',
          master: this.$mapForMaster(this.mPeriode),
          props: ['attach'],
          grid: { cols: 12, md: 6 },
        });
      }

      if (['daring', 'luring'].includes(this.akses)) {
        temp.push({
          label: 'Jenis Diklat',
          default: true,
          type: 'select',
          model: 'k_diklat_paud',
          master: this.$mapForMaster(this.M_DIKLAT_PAUD).filter((s) => Number(s.value) < 4),
          props: ['attach'],
          grid: { cols: 12, md: 6 },
        });
        temp.push({
          label: 'Jenjang Diklat',
          default: true,
          type: 'select',
          model: 'k_jenjang_diklat_paud',
          master: this.$mapForMaster(this.M_JENJANG_DIKLAT_PAUD),
          props: ['attach'],
          grid: { cols: 12, md: 6 },
        });
      }

      if (this.akses === 'luring') {
        temp.push({
          label: 'Pembiayaan',
          default: true,
          type: 'select',
          model: 'k_pembiayaan_paud',
          master: this.$mapForMaster(this.masters['m_pembiayaan_paud']),
          props: ['attach'],
          grid: { cols: 12, md: 6 },
        });
      }

      return temp;
    },

    filtersMaster() {
      return {
        k_verval_paud: this.mapStatusVerval,
        paud_periode_id: this.mPeriode,
        k_diklat_paud: this.M_DIKLAT_PAUD,
        k_jenjang_diklat_paud: this.M_JENJANG_DIKLAT_PAUD,
        k_pembiayaan_paud: this.masters && this.masters.m_pembiayaan_paud,
      };
    },

    obj() {
      return this.$route.meta.atribut;
    },

    jenis() {
      return (this.$route.meta && this.$route.meta.tipe) || 'kelas';
    },

    akses() {
      return (this.$route.meta && this.$route.meta.akses) || 'daring';
    },

    label() {
      return this.M_LABEL[this.akses];
    },
  },
  mounted() {
    Object.assign(this.attr, { type: this.akses });
  },
  created() {
    this.getMasters({
      name: ['m_verval_paud', ...(this.akses === 'luring' ? ['m_pembiayaan_paud'] : [])].join(';'),
    });
    this.getPeriode({}).then(({ data }) => {
      this.mPeriode = {};
      const items = data || [];

      items.forEach((item) => {
        this.$set(this.mPeriode, this.getId(item), item.nama);
      });
    });
  },
  methods: {
    ...mapActions('diklatVerval', [
      'fetch',
      'getStatistik',
      'getDetail',
      'action',
      'downloadList',
      'getKinerja',
      'getTimVerval',
      'getPeriode',
    ]),
    ...mapActions('master', ['getMasters']),

    getId(item) {
      return item[`paud_kelas${this.label}_id`];
    },

    fetchData: function () {
      return new Promise((resolve) => {
        if (this.jenis === 'kelas-luring') {
          this.params['tahun'] = this.tahun;
        }

        const params = Object.assign({}, this.params, this.$isObject(this.filters) ? { filter: this.filters } : {});
        const attr = Object.assign({}, this.attr);
        this.fetch({ params, attr }).then((resp) => {
          this.data = resp.data || [];
          this.total = resp?.total ?? 0;
          this.pageTotal = resp?.last_page ?? 1;

          resolve(true);
        });
      });
    },

    allow(action, data) {
      let allow = false;
      const kVerval = this.getKVerval(data);
      switch (action.event) {
        case 'onBatalVerval':
          allow =
            this.$allow(action.akses) &&
            Number(kVerval) > 3 &&
            [1, null, undefined].includes(data.laporan_k_verval_paud);
          break;
        default:
          allow = this.$allow(action.akses);
          break;
      }
      return allow;
    },

    allowVerval(item) {
      const kVerval = this.getKVerval(item);
      return this.$allow('kelas-verval.update-verval') && kVerval <= 3;
    },

    getKVerval(item) {
      return Number(item.k_verval_paud);
    },

    onClose() {
      if (!this.formulir['autoClose']) {
        const msg = [
          '<h3>Apakah Anda yakin ingin keluar dari halaman Verifikasi Ajuan Kelas ?</h3>',
          'data yang tidak disimpan akan hilang jika Anda keluar dari Halaman ini',
        ].join(' ');
        this.$confirm(msg, 'Peringatan', { tipe: 'error', lblConfirmColor: 'red', lblCancelColor: 'grey' }).then(() => {
          this.$refs.modal.dialog = false;
        });
      }
    },

    async initFetch() {
      await this.fetchData();
      if (this.jenis === 'kelas-luring') {
        await this.fetchStatistik();
      }
    },

    async fetchStatistik() {
      const resp = await this.getStatistik();

      for (const id in this.boxes) {
        this.boxes[id]['value'] = (resp && resp[this.boxes[id]['key']]) || 0;
      }

      return resp;
    },

    async onVerval(item) {
      const kVerval = item.k_verval_paud;
      const status = {
        color: this.getColor(kVerval),
        keterangan: this.$getDeepObj(item, 'm_verval_paud.keterangan'),
      };

      let init = {};

      init = {
        pilihan: kVerval <= 3 ? null : kVerval === 4 ? 1 : kVerval === 6 ? 2 : 3,
        catatan: item.alasan || '',
      };

      this.$set(this.formulir, 'form', 'form-verval');
      this.$set(this.formulir, 'title', 'Verval Ajuan');
      this.$set(this.formulir, 'id', this.getId(item));
      this.$set(this.formulir, 'init', null);

      this.getDetail({ id: this.getId(item) }).then(({ data }) => {
        this.$set(this.formulir, 'is_disable', !this.allowVerval(item));
        this.$set(this.formulir, 'is_edit', this.allowVerval(item));
        this.$set(this.formulir, 'autoClose', !this.allowVerval(item));

        this.$refs.modal.open();
        this.$nextTick(() => {
          this.$refs.formulir.reset();
          this.$set(this.formulir, 'init', init);
          this.$set(this.formulir, 'detail', data);
          this.$set(this.formulir.detail, 'status', status);
        });
      });
    },

    onSave() {
      const formulir = Object.assign({}, this.$refs.formulir.getValue());
      const status = formulir.pilihan;
      const alasan = formulir.alasan || '-';
      const id = formulir.id;

      if (status) {
        const aksi = status === 1 ? '4' : status === 2 ? '6' : '5';
        const html = `<span class="subtitle-1">Anda Yakin ingin <strong>${
          status === 1 ? 'menolak' : status === 2 ? 'menerima' : 'menyatakan perbaikan'
        }</strong> ajuan verval berikut ?</span>`;

        this.$confirm(html, 'Konfirmasi', { tipe: status === 1 ? 'error' : status === 2 ? 'success' : 'warning' }).then(
          () => {
            this.$refs.modal.loading = true;
            this.action({ id: id, params: { k_verval_paud: aksi, alasan }, type: 'verval' })
              .then(async () => {
                this.$success('Ajuan berhasil di verifikasi');
                this.$refs.modal.dialog = false;
                await this.onReload();
                await this.fetchStatistik();
              })
              .catch(() => {
                this.$refs.modal.loading = false;
              });
          }
        );
        this.$refs.modal.loading = false;
      } else {
        this.$error('Silakan tentukan hasil verifikasi data sebelum simpan');
        this.$refs.modal.loading = false;
      }
    },

    onKunci(data) {
      this.$confirm(`Anda yakin ingin mengunci Ajuan di atas agar bisa diverifikasi?`, `Kunci Ajuan`, {
        tipe: 'warning',
        data: this.confirmHtml(data),
      }).then(() => {
        this.action({ id: this.getId(data), jenis: this.jenis, type: 'kunci', method: 'get' }).then(() => {
          this.$success(`Ajuan Peserta berhasil dikunci`);
          this.onReload();
        });
      });
    },

    onBatalKunci(data) {
      this.$confirm(`Anda yakin ingin membatalkan Kunci Verifikasi Ajuan Peserta di atas?`, `Batal Kunci Ajuan`, {
        tipe: 'error',
        data: this.confirmHtml(data),
      }).then(() => {
        this.action({ id: this.getId(data), jenis: this.jenis, type: 'batal-kunci', method: 'get' }).then(() => {
          this.$success(`Batal kunci Ajuan Peserta berhasil`);
          this.onReload();
        });
      });
    },

    onBatalVerval(data) {
      this.$confirm(`Anda yakin ingin membatalkan VerVal Ajuan di atas?`, `Batal Verval`, {
        tipe: 'error',
        data: this.confirmHtml(data),
      }).then(() => {
        this.action({ id: this.getId(data), type: 'batal-verval', method: 'post' }).then(async () => {
          this.$success(`Batal Verval Ajuan Kelas Diklat berhasil`);

          await this.onReload();
          await this.fetchStatistik();
        });
      });
    },

    confirmHtml(data) {
      const nama =
        this.$getDeepObj(data, 'paud_mapel_kelas.nama') || this.$getDeepObj(data, 'paud_diklat_bimtek.nama') || '-';

      return [
        {
          icon: 'mdi-account-circle',
          iconSize: 50,
          iconColor: 'primary',
          title: `<b class='primary--text'>${nama}</b>`,
          subtitles: [`<span class="text--primary">${data.nama}</span>`],
        },
      ];
    },

    onDownload() {
      const M_LAPORAN = [
        {
          key: 'download',
          label: `Laporan Verval Kelas Diklat`,
          acl: `${this.jenis}-verval.download`,
        },
        {
          key: 'download-detil',
          label: `Laporan Detail Verval Kelas Diklat`,
          acl: `${this.jenis === 'kelas-luring'}`,
        },
      ];

      let url = {};
      this.$confirm('Pilih jenis Berkas yang ingin di Unduh?', 'Unduh Berkas', {
        tipe: 'secondary',
        form: {
          desc: 'Laporan Berkas',
          render: (h) => {
            return h(
              'select',
              {
                class: 'custom-select',
                domProps: {
                  value: '',
                },
                on: {
                  input: function (event) {
                    url.dokumen = event.target.value;
                  },
                },
              },
              [
                h('option', { attrs: { value: '' } }, '-- Pilih Jenis Unduhan --'),
                M_LAPORAN.filter((laporan) => this.$allow(laporan.acl)).map((item) =>
                  h('option', { attrs: { value: item.key } }, item.label)
                ),
              ]
            );
          },
        },
        lblConfirmButton: 'Unduh',
      }).then(() => {
        if (!url.dokumen) {
          this.$error('Silakan pilih laporan yang ingin diunduh!');
          return;
        }

        const params = Object.assign(this.params, this.$isObject(this.filters) ? this.filters : {});
        this.downloadList({ params, url: url.dokumen, jenis: this.jenis }).then((url) => {
          this.$downloadFile(url);
        });
      });
    },

    onSync(data) {
      this.action({ id: this.getId(data), params: {}, type: 'sync' })
        .then(() => {
          this.$success('Aksi berhasil dijalankan');
          this.$refs.modal.dialog = false;
          this.onReload();
        })
        .catch(() => {
          this.$refs.modal.loading = false;
        });
    },

    isEndDiklat(item) {
      const now = new Date();
      const wkt_selesai = this.$getDeepObj(item, `paud_diklat.paud_periode.tgl_diklat_selesai`);
      const wkt_penilaian = new Date(wkt_selesai);
      return now >= wkt_penilaian;
    },

    onCatatan(data) {
      const id = data[`paud_kelas${this.label}_id`];
      if (this.catatans && this.catatans[id]) {
        this.$delete(this.catatans, id);
      } else {
        this.$set(this.catatans, id, true);
      }
    },
  },
};
</script>

<style scoped>
.bg-kiri {
  background: #ffab91;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
</style>
